<template>
    <v-main>
        <div class="stepper-2">
            <div id="move-step2">
                <StepperBar v-if="registrationFormDetail" :stepOn="StepperType" :stepper="2" />
            </div>
        </div>
        <v-container class="spacing-playground form-margin-top">
            <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="7"
                    class="
                        d-flex
                        justify-md-end justify-sm-center justify-xs-center
                    "
                >
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                        v-if="timeout"
                    >
                        <v-card-text class="pb-1">
                            <div class="my-1 prompt-title">
                                {{ $t('message.step2.topic')}} 
                            </div>
                            <v-row class="mb-2">
                                <v-col cols="12" md="12" sm="12">
                                    <div
                                        class="pa-0 py-1 prompt-caption"
                                        style="color: #37323c; font-weight: 500"
                                    >
                                        {{ $t('message.step2.step.topic')}} 
                                    </div>
                                    <div
                                        class="mb-1 ml-1"
                                        style="
                                            list-style-type: decimal;
                                            color: #37323c;
                                        "
                                    >
                                        <li>{{ $t('message.step2.step.step1')}}</li>
                                        <li>{{ $t('message.step2.step.step2')}}</li>
                                        <li>{{ $t('message.step2.step.step3')}}</li>
                                        <li>{{ $t('message.step2.step.step4')}}</li>
                                        <li>{{ $t('message.step2.step.step5')}}</li>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-divider class="ma-1"></v-divider>
                            <v-row class="mt-6 mb-3">
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="6"
                                    md="6"
                                    class="py-0 my-1"
                                >
                                    <div
                                        class="pa-0 prompt-caption"
                                        style="color: #37323c"
                                    >
                                        {{ $t('message.step2.accountName')}} : {{
                                            organization?.[`name_${locale}`]
                                        }}
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    xs="12"
                                    sm="6"
                                    md="6"
                                    class="py-0 my-1"
                                >
                                    <v-chip
                                        class="ma-0"
                                        color="#6FA2CC4D"
                                        style="width: 100%; height: 40px"
                                    >
                                        <v-row>
                                            <v-col
                                                cols="8"
                                                sm="8"
                                                md="8"
                                                style="
                                                    display: flex;
                                                    align-items: center;
                                                "
                                            >
                                                <div
                                                    class="prompt-caption-blue"
                                                >
                                                    {{ $t('message.step2.totalAmount')}}
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="4"
                                                xs="4"
                                                md="4"
                                                sm="4"
                                            >
                                                <div class="prompt-title">
                                                    {{
                                                        registrationFormDetail?.fee
                                                    }}
                                                    {{ $t('message.step2.baht')}}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-chip>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="d-flex justify-center a"
                                        >
                                            <v-sheet
                                                :rounded="'lg'"
                                                color="#D4D9DE"
                                                elevation="1"
                                                height="160"
                                                width="160"
                                                class="d-flex align-center"
                                            >
                                                <v-img
                                                    v-if="!paymentData"
                                                    :src="
                                                        require('@/assets/qr_code.svg')
                                                    "
                                                    contain
                                                    height="30"
                                                />
                                                <v-img
                                                    v-else
                                                    :src="paymentData?.qrCodeUrl"
                                                    contain
                                                    height="150"
                                                />
                                            </v-sheet>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="my-3 text-center sarabun-16"
                                        >
                                            <div id="step2-text">
                                                <strong>*</strong>
                                                {{ $t('message.step2.content')}}
                                                <label
                                                    style="color: #ff9800"
                                                    v-if="limitTime != 0"
                                                >
                                                    {{ limitTimeMinute }}
                                                    : {{ limitTimeSecond }}
                                                </label>
                                                <label
                                                    style="color: #ff9800"
                                                    v-else
                                                >
                                                    10 : 00
                                                </label>
                                                {{ $t('message.step2.content2')}}
                                            </div>
                                        </v-col>
                                        <v-col
                                            xs="12"
                                            sm="12"
                                            md="12"
                                            class="text-center"
                                        >
                                            <v-btn
                                                class="prompt-chip orange-shadow"
                                                rounded
                                                color="#FF9800"
                                                outlined
                                                height="40"
                                                width="250"
                                                @click="getQRCode"
                                                :disabled="createQR"
                                                >{{ $t('message.step2.scan')}}</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-row>
                                        <UploadEvidenceFile
                                            ref="uploadDocument"
                                            elementKey="uploadPayment"
                                            :student_id="student_id"
                                            :evidenceDetail="uploadFileDetail?.evidenceDetail"
                                            :evidenceCondition="uploadFileDetail?.evidenceCondition"
                                            :is_picture="true"
                                            @uploadComplete="getUrl"
                                        />
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                        v-else
                    >
                        <v-card-text class="py-16">
                            <v-row class="py-10 mt-6 mb-3" align="center">
                                <v-col md="12" class="d-flex justify-center">
                                    <v-img
                                        :src="require('@/assets/wrong.svg')"
                                        contain
                                        height="50"
                                    />
                                </v-col>
                                <v-col
                                    md="12"
                                    class="my-1 d-flex justify-center"
                                    style="padding: 0 7rem"
                                >
                                    <div class="prompt-title-page">
                                        {{ $t('message.step2.outOfDeadline') }}
                                    </div>
                                </v-col>
                                <v-col
                                    md="12"
                                    class="my-3 d-flex justify-center"
                                    style="padding: 0 7rem"
                                >
                                    <div class="form-label-400">
                                        {{ $t('message.step2.content_outOfDeadline')}}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="5"
                    id="step-sidebar"
                    class="ma-0 px-0"
                >
                    <v-card id="step-sidebar-card">
                        <v-card-text>
                            <v-row>
                                <v-col cols="10">
                                    <div class="pa-0 prompt-title">
                                        {{ $t('message.formSummit.applicationForm')}}
                                    </div>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn icon @click="closeBar"
                                        ><v-icon id="dropbar-icon"
                                            >mdi-menu-down</v-icon
                                        ></v-btn
                                    >
                                </v-col>
                            </v-row>
                            <template v-if="closeActive === true">
                                <div class="pa-0 mt-4 prompt-caption">
                                    {{ $t('message.formSummit.school')}}
                                </div>
                                <div
                                    class="pa-0 mt-0 mb-3 step2__text__size18"
                                >
                                    {{ organization?.[`name_${locale}`] }} 
                                </div>
                                <v-divider class="mt-5 mb-5"></v-divider>
                                <v-row>
                                    <v-col
                                        ><div class="pa-0 mb-4 prompt-title">
                                            {{ $t('message.formSummit.status')}}
                                        </div></v-col
                                    >
                                    <v-col
                                        ><div class="pa-0 mb-4 prompt-title">
                                            <v-chip
                                                class="ma-0"
                                                color="#EBEBEC"
                                            >
                                                <v-icon color="#FF544A" left
                                                    >mdi-currency-usd-off</v-icon
                                                >
                                                <div class="prompt-chip pt-1">
                                                    {{ $t('message.step2.pending_payment') }} 
                                                </div>
                                            </v-chip>
                                        </div></v-col
                                    >
                                </v-row>
                                <div class="pa-0 prompt-caption">
                                    {{ $t('message.formSummit.termOfPayment') }}
                                </div>
                                <div
                                    class="pa-0 mt-0 mb-3 step2__text__size18"
                                    v-if="timeout === true"
                                >
                                    {{ $t('message.formSummit.within')}} {{ paymentEndDate }}
                                </div>
                                <div
                                    class="pa-0 mt-0 mb-3 step2__text__size18__error"
                                    v-if="timeout === false"
                                >
                                    {{ $t('message.formSummit.within')}} {{ paymentEndDate }}
                                </div>
                            </template>
                            <v-btn
                                class="my-5 prompt-"
                                block
                                rounded
                                :color="checkFill ? '#FF9800' : '#AFADB1'"
                                height="40"
                                v-if="timeout === true"
                                :disabled="!checkFill"
                                style="
                                    font-weight: 400;
                                    color: white
                                    font-size: 18px;
                                    line-height: 24px;
                                    letter-spacing: 0.05rem;
                                "
                                @click="clickPaymentConfirmation"
                            >
                                {{ $t('message.formSummit.confirmPayment')}}
                            </v-btn>
                            <v-row>
                                <v-col class="pr-0 pt-7"
                                    ><div
                                        class="pa-0 mt-0 mb-3 mx-auto step2__text__size14"
                                    >
                                        Customer Service LINE
                                    </div></v-col
                                >
                                <v-col
                                    ><v-img
                                        :src="
                                            require('../../src/assets/lineBtn.svg')
                                        "
                                        class="my-3"
                                        contain
                                        height="36"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="5" class="ma-0 px-0">
                    <div style="height: 380px" id="height-overflow"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import StepperBar from "./StepperBar";
import UploadEvidenceFile from '@/components/fileElement/UploadEvidenceFile.vue'
import * as services from "@/services";
import { dateTimeLocale, formatDateTimeLocale } from "@/utils/date";
import dayjs from "dayjs";
import i18n from '@/i18n';

export default {
    name: "StepTwo",
    data: () => ({
        inputStep2: { show: false, color: "", fileName: "", fullFileName: "", file: null },
        organization: null,
        closeActive: true,
        id: null,
        student: null,
        limitTime: 0,
        createQR: false,
        paymentData: null,
        uploadFileDetail:{
            evidenceDetail: {
                name: 'AchievePayment',
            },
            evidenceCondition: {
            }
        },
        paymentEvidence: null
    }),
    props: {
        registrationFormDetail: Object,
        student_id: Number,
    },
    components: { StepperBar, UploadEvidenceFile },
    computed: {
        locale() {
            return i18n.locale;
        },
        paymentEndDate() {
            let newDate = new Date( this.registrationFormDetail?.payment_end_date);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        timeout() {
            let endDate = new Date(this.registrationFormDetail?.payment_end_date);
            endDate.setDate(endDate.getDate() + 1)
            endDate = endDate.setHours(0)
            return this.compareDateIsBefore(new Date(), endDate);
        },
        limitTimeMinute() {
            return Math.floor(this.limitTime / 60) < 10
                ? "0" + Math.floor(this.limitTime / 60)
                : Math.floor(this.limitTime / 60);
        },
        limitTimeSecond() {
            return this.limitTime % 60 < 10
                ? "0" + (this.limitTime % 60)
                : this.limitTime % 60;
        },
        checkFill() {
            return this.createQR && this.inputStep2?.show;
        },
        StepperType(){
            if(this.registrationFormDetail != null && !(this.registrationFormDetail?.fee == 0 || this.registrationFormDetail?.fee == null))
                return true
            else
                return false
        },
        studentFullName(){
            return `${this.student?.student_detail?.prefix_id?.[`text_${this.locale}`]} ${this.student?.student_detail?.[`name_${this.locale}`]} ${this.student?.student_detail?.[`surname_${this.locale}`]}`
        }
    },
    methods: {
        getUrl(input, url){
            this.inputStep2 = input
            this.paymentEvidence = url
        },
        compareDateIsBefore(from, to) {
            if (!from || !to) return true;
            if (dayjs(to).isSameOrBefore(dayjs(from))) return false;
            return true;
        },
        async clickPaymentConfirmation() {
            try {
                this.$emit('loadingUpdate',1)
                if(this.inputStep2?.show){
                    this.paymentEvidence = await this.$refs?.uploadDocument?.confirmUploadFile()
                    if(this.paymentEvidence != null){
                        const res = await services.sentPaymentEvidence({
                            token: localStorage.getItem("token"),
                            transaction_number: this.paymentData?.transactionNo,
                            is_student_upload: true,
                            payment_evidence: this.paymentEvidence?.url,
                        });
                        if(res.data.status == "ok"){
                            location.reload();
                        }
                        else{
                            await services.deleteDocumentFile({
                                fileName: this.paymentEvidence?.fileName,
                                module: this.paymentEvidence?.module
                            },this.student?.id
                            )
                        }
                    }
                }
            } catch (err) {
                await services.deleteDocumentFile({
                    fileName: this.paymentEvidence?.fileName,
                    module: this.paymentEvidence?.module
                },this.student?.id
                )
                this.paymentEvidence = null
            }
            finally{
                this.$emit('loadingUpdate',-1)
            }
            this.dialog = false;
        },
        closeBar() {
            if (this.closeActive) {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(180deg)";
                document.getElementById("height-overflow").style.height =
                    "180px";
            } else {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(0deg)";
                document.getElementById("height-overflow").style.height =
                    "380px";
            }
            this.closeActive = !this.closeActive;
        },
        countDownTimer() {
            if (!this.createQR && this.limitTime <= 0) {
                this.limitTime = 600;
                this.createQR = true;
                this.countDownTimer();
            } else if (this.createQR) {
                if (this.limitTime > 0) {
                    setTimeout(() => {
                        this.limitTime -= 1;
                        this.countDownTimer();
                    }, 1000);
                } else {
                    this.createQR = false;
                    this.paymentData = null;
                }
            }
        },
        async getQRCode() {
            try{
            this.$emit('loadingUpdate',1)
            let body = {
                token: localStorage.getItem("token"),
                query: {
                    selects: {
                        id: true,
                        student_detail: {
                            prefix_id: {
                                text_th: true,
                                text_en: true,
                            },
                            name_th: true,
                            surname_th: true,
                            name_en: true,
                            surname_en: true,
                        },
                    },
                    relations: {
                        student_detail: {
                            prefix_id: true,
                        },
                    },
                },
            };
            const { data: { data: { student }}} = await services.getStudentWithQuery(body);
            this.student = student;
            if(student){
                body = {
                    userAccountId: this.student?.id,
                    amount: this.registrationFormDetail?.fee || 0,
                    schoolCode: this.organization?.school_code,
                    fullName: this.studentFullName,
                    callbackUrl: `${process.env.VUE_APP_API_URL}/payment/callback`,
                };
                
                const res = await services.generatePayment(body);
                if (res.data.status == "ok") {
                    this.paymentData = res.data.data;
    
                    // for auto create payment
                    // for local only
                    const mock = false;
                    if (mock == true) {
                        const body = {
                            userAccountId: this.paymentData.userAccountId,
                            transactionNo: this.paymentData.transactionNo,
                            txnAmount: this.registrationFormDetail.fee,
                            txnDate: dateTimeLocale(),
                        };
                        await services.sentPaymentCallback(body);
                    }
                    
                    this.countDownTimer();
                }
            }
            else{
                throw "can't generate qr code because can't get student info"
            }
            }
            catch(err){
                console.log(err)
            }
            finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        async getOrganization(){
            try{
                this.$emit("loadingUpdate", 1);
                let res = await services.getOrganization();
                this.organization = res.data.data.organization
            }
            finally{
                this.$emit("loadingUpdate", -1);
            }
        }
    },
    mounted() {
        this.getOrganization();
    }
};
</script>

<style scoped lang="scss">
.orange-shadow{
    box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
}

.orange-shadow:disabled{
    box-shadow: 0px 0px 20px rgba(255, 152, 0, 0);
}

.step2__text__size18{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.step2__text__size18__error{
    color: #ff544a;
    font-family: 'Sarabun';
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.step2__text__size14{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 14px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
</style>
